import { UtilsMisc } from '../../utils/utils.misc';

export interface IConfigAuth {

    authUserName: string;
    authPassword: string;
    accessToken: string;
    refreshToken: string;
    useAuth: boolean;
    userName: string;

    accessTokenCommunicationChannel: string;

}

// @dynamic
export class ConfigAuth {

    private static _authUserName: string = null;
    private static _authPassword: string = null;
    private static _accessToken: string = null;
    private static _refreshToken: string = null;
    private static _useAuth: boolean = false;
    private static _userName: string = null;
    private static _accessTokenCommunicationChannel: string = null;

    public static get authUserName(): string {
        return ConfigAuth._authUserName;
    }

    public static set authUserName(value: string) {
        ConfigAuth._authUserName = value;
    }

    public static get authPassword(): string {
        return ConfigAuth._authPassword;
    }

    public static set authPassword(value: string) {
        ConfigAuth._authPassword = value;
    }

    public static get accessToken(): string {
        return ConfigAuth._accessToken;
    }

    public static set accessToken(value: string) {
        ConfigAuth._accessToken = value;
    }

    public static get refreshToken(): string {
        return ConfigAuth._refreshToken;
    }

    public static set refreshToken(value: string) {
        ConfigAuth._refreshToken = value;
    }

    public static get useAuth(): boolean {
        return ConfigAuth._useAuth;
    }

    public static set useAuth(value: boolean) {
        ConfigAuth._useAuth = value;
    }

    public static get userName(): string {
        return ConfigAuth._userName;
    }

    public static set userName(value: string) {
        ConfigAuth._userName = value;
    }

    public static get accessTokenCommunicationChannel(): string {
        return ConfigAuth._accessTokenCommunicationChannel;
    }

    public static set accessTokenCommunicationChannel(value: string) {
        ConfigAuth._accessTokenCommunicationChannel = value;
    }

    public static assign(source: IConfigAuth): void {
        if (UtilsMisc.isNullOrUndefinedOrEmpty(source) === false) {
            ConfigAuth._authPassword = source.authPassword;
            ConfigAuth._authUserName = source.authUserName;
            ConfigAuth._accessToken = source.accessToken;
            ConfigAuth._refreshToken = source.refreshToken;
            ConfigAuth._useAuth = source.useAuth;
            ConfigAuth._userName = source.userName;
            ConfigAuth._accessTokenCommunicationChannel = source.accessTokenCommunicationChannel;
        }
    }

}
